<script lang="ts">
import { requiredRule } from "@/lib/rules/requiredRule";
import { rules, RulesEnum } from "@/lib/rules/rules.map";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class RulesMixin extends Vue {
  readonly RulesEnum = RulesEnum;
  readonly rules = rules;

  get requiredRule() {
    return [requiredRule()];
  }

  /**
   * hides error text
   */
  get requiredRuleSilent() {
    return [requiredRule(" ")];
  }
}
</script>
